<template>
  <div class="pageBody">
    <div class="ohead">
      <el-input placeholder="请输入交易号" v-model="form.tradeno"></el-input>
      <el-input
        placeholder="请输入客户名称或者ID"
        v-model="form.userInfo"
      ></el-input>
      <el-input placeholder="请输入业务员名称" v-model="form.y_name"></el-input>
      <span>交易付款时间：</span>
      <el-date-picker
        v-model="val"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-select
        filterable
        v-model="form.gDepartment"
        placeholder="请选择采购部门"
        clearable
      >
        <el-option
          v-for="item in department"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="getData">查 询</el-button>
    </div>
    <div class="buttongroup">
      <el-button type="success" @click="handleExportExcel">导出清单</el-button>
    </div>
    <div
      style="color: red; font-size: 12px; text-align: right; margin-left: auto"
    >
      推荐一次导出七天数据，否则可能因数据量过大导出失败
    </div>
    <div class="BodyRow">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="tradeno" label="交易号" width="180px">
        </el-table-column>
        <el-table-column prop="ordno" label="客户订单号" width="180px">
        </el-table-column>
        <el-table-column label="客户名称/ID" width="190px">
          <template slot-scope="scope">
            <div>{{ scope.row.realname }}/{{ scope.row.user_id }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="shippingFee" label="运费"> </el-table-column>

        <el-table-column prop="kin" label="原订单金额（CNY）">
        </el-table-column>
        <el-table-column prop="totalAmount" label="采购实际支出金额（CNY）">
        </el-table-column>

        <el-table-column prop="guoName" label="采购支付账号"> </el-table-column>
        <el-table-column prop="datetime" label="交易付款时间">
        </el-table-column>
        <el-table-column prop="y_name" label="业务员"> </el-table-column>
        <el-table-column prop="department_name" label="业务部门">
        </el-table-column>
        <el-table-column prop="g_name" label="采购员"> </el-table-column>
        <el-table-column prop="gDepartment" label="采购部门"> </el-table-column>
      </el-table>
    </div>
    <div class="allpag">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="form.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getCurrentMonthFirst,
  getNowDate,
  getCurrentDayBefo,
} from "@/utlis/date";
import { payState, formatDateCommon } from "@/utlis/orderData";
export default {
  data() {
    return {
      formatDateCommon: formatDateCommon,
      currentPage4: 1,
      total: 0,
      pageSize: 10,
      department: [],
      options: payState,
      val: "",
      form: {
        beginDatetime: null, //开始时间
        endDatetime: null, //结束时间
        tradeno: "", //交易号
        page: 1,
        pagesize: 50,
        userInfo: "", //客户名或者用户ID
        y_name: "", //业务员名字
        gDepartment: "", //采购部门
      },
      tableData: [],
    };
  },
  created() {
    // this.val = [getCurrentDayBefo(), getCurrentDayBefo()];
    // this.form.beginDatetime = getCurrentDayBefo();
    // this.form.endDatetime = getCurrentDayBefo();
    // this.getData();
    // console.log(getCurrentDayBefo());
  },
  watch: {
    val() {
      if (!this.val) {
        this.form.beginDatetime = null;
        this.form.endDatetime = null;
        return false;
      }
      this.form.beginDatetime = this.val[0];
      this.form.endDatetime = this.val[1];
    },
  },
  computed: {},
  methods: {
    //   导出表格
    async handleExportExcel() {
      var tabledata = [];
      var form = JSON.parse(JSON.stringify(this.form));
      form.page = 1;
      // form.pagesize = Number(this.total) + 50;
      form.pagesize = 99999999999999;
      console.log(form);
      await this.$api.financialApi
        .taobaoPayoffOrdno(form)
        .then((res) => {
          console.log(res);
          tabledata = res.data.list;
        })
        .catch((err) => {
          this.$message.warning("错误");
          return false;
        });
      if (!this.tableData) {
        this.$message.warning("暂无数据");
        return false;
      }

      require.ensure([], () => {
        const { export_json_to_excel } = require("@/utlis/Export2Excel");
        const tHeader = [
          "交易号",
          "客户订单号",
          "客户名称",
          "客户ID",
          "运费",
          "原订单金额（CNY）",
          "采购实际支出金额（CNY）",
          "采购支付账号",
          "交易付款时间",
          "业务员",
          "业务部门",
          "采购员",
          "采购部门",
        ];
        const filterVal = [
          "tradeno",
          "ordno",
          "realname",
          "user_id",
          "shippingFee",
          "kin",
          "totalAmount",
          "guoName",
          "datetime",
          "y_name",
          "department_name",
          "g_name",
          "gDepartment",
        ];
        const list = tabledata; //把data里的tableData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "taoBao付款订单列表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getData() {
      this.$api.financialApi
        .taobaoPayoffOrdno(this.form)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.list;
          this.total = Number(res.data.total);
          this.department = res.department;
        })
        .catch((err) => {
          this.tableData = [];
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.pagesize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getData();
    },
  },
};
</script>
<style scoped lang="scss">
.ohead {
  display: flex;
  align-items: center;

  * {
    margin-right: 15px;
  }

  .el-input {
    width: 220px;
  }
}

.buttongroup {
  margin: 20px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  span {
    margin-right: 150px;
    font-size: 20px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>
